import { FC } from 'react';
import { useIntl } from 'react-intl';

import { StatusMessage } from '~/eds/src/components/StatusMessage/StatusMessage';
import { StatusType } from '~/eds/src/types/StatusType';

import { IntegrationMessageType } from '../utils/helper';
import { StatusMessageConfig } from './ESignatureIntegration.config';

export type IntegrationStatusMessageProps = {
  type: IntegrationMessageType;
  providerName: string;
  errorMessage?: string;
};

export const IntegrationStatusMessage: FC<IntegrationStatusMessageProps> = ({
  errorMessage,
  type,
  providerName,
}) => {
  const intl = useIntl();
  const config = StatusMessageConfig[type!];

  if (!config) {
    return null;
  }
  return (
    <StatusMessage
      key={type}
      status={config.status as StatusType}
      message={
        errorMessage ?? intl.formatMessage(config.message, { providerName })
      }
    />
  );
};
